/*
	«Aplicar Promoción»: cuando una opción sale bloqueada, además del motivo (lo manda el servidor) se enseña el SIGUIENTE PASO.
	El motivo se reconoce por su texto; si no se reconoce, queda el paso general. Title Case, una línea.
*/
const REGLAS: [RegExp, string][] = [
	// «Falta actualizar la base…»: el mensaje del servidor ya dice qué hacer (el pago sin la promoción sí se registra); no se le agrega paso.
	[/falta actualizar la base/i, ""],
	[/se toma pagando a más tardar/i, "Elige Otra Promoción o Cobra Sin Promoción"],
	[/no está vigente/i, "Elige una Promoción Vigente"],
	[/es de otro plantel/i, "Cambia al Plantel de la Matrícula"],
	[/es para cursos de/i, "Elige la Promoción de la Duración del Curso"],
	[/ya está aplicada en esta matrícula/i, "Revísala en Promociones"],
	[/ya tiene pagos|está en la factura|ya tiene abono o factura/i, "Cobra los Meses Normal o Elige Otra Promoción"],
	[/no tiene regalo configurado/i, "Configura el Regalo en Catálogo de Promos"],
	[/no tiene en el catálogo el kit/i, "Elige el Kit en Catálogo de Promos"],
	[/no está activo o no tiene precio/i, "Activa el Kit o Ponle Precio en Tienda"],
	[/no deja .* en \$0/i, "Corrige el Descuento de la Promoción en Catálogo de Promos"],
	[/ya tiene «/i, "Elige Otra Promoción"],
	[/pide \d+ mensualidades pagadas/i, "Elige la Promoción del Curso Correcto"],
	[/tiene descuento en «/i, "Quita Ese Descuento en Promociones, Acuerdos"],
	[/no tiene mensualidades/i, "Elige Otra Matrícula como Base"],
	[/ya tiene mensualidades pagadas con/i, "Elige Otra Promoción"],
	[/ya está en otro acuerdo|acuerdo/i, "Pide a Supervisión de Caja Anular el Acuerdo"],
];

export const siguientePaso = (blocked: string | null | undefined): string | null => {
	if (!blocked) return null;
	const hit = REGLAS.find(([re]) => re.test(blocked));
	if (hit && !hit[1]) return null;
	return hit ? hit[1] : "Elige Otra Promoción o Pide Apoyo a Supervisión de Caja";
};

/** El bloqueo es porque la promo toca a otra persona (grupo, 2x1, 50 %) o quita una beca: no se pide, la cambia Caja con «Cambiar Promoción». */
export const esBloqueoLigado = (o: { blocked?: string | null; blockedLinked?: boolean }): boolean =>
	!!o.blocked && (o.blockedLinked === true || /ligad|otra persona|otras personas|beca/i.test(o.blocked));
